export default "__VITE_ASSET__BG_QoVi8__"